import { createFetcher } from '../../Fetcher/Fetcher'
import { ADMIN_ENDPOINT, getBaseUrl, QUIZ_ENDPOINT } from '../../constant'

/**
 * Creates a new Quiz.
 * @Applications
 */
export default class Question {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Question(
        QUIZ_ENDPOINT,
        ADMIN_ENDPOINT,
        createFetcher()
      )
    }
    return this.instance
  }

  constructor(endpoint, adminEndPoint, fetcherObj) {
    this.endpoint = endpoint
    this.adminEndPoint = adminEndPoint
    this.fetcher = fetcherObj
  }

  static get baseUrl() {
    return getBaseUrl()
  }

  async postQuestion(reqData) {
    const url = `${Question.baseUrl + this.adminEndPoint}/question`
    const response = await this.fetcher.postData(url, reqData)
    return response
  }

  async putQuestion(reqQuizId, reqQuestionId, reqQuestionType, reqData) {
    const url = `${Question.baseUrl + this.adminEndPoint}/question/${
      reqData?.id
    }`
    const response = await this.fetcher.putData(url, reqData)
    return response
  }

  async deleteQuestionById(reqData) {
    const url = `${Question.baseUrl + this.adminEndPoint + this.endpoint}/${
      reqData?.quizId
    }/question/${reqData?.questionId}`
    const response = await this.fetcher.deleteData(url)
    return response
  }

  async deleteQuestionMappingById(reqData) {
    const url = `${Question.baseUrl + this.adminEndPoint + this.endpoint}/${
      reqData?.quizId
    }/question/${reqData?.questionId}`
    const response = await this.fetcher.deleteData(url)
    return response
  }

  async postQuestionMapping(reqQuizId, reqData) {
    const quizId = reqData?.quizId ? reqData?.quizId : reqQuizId
    const questionId = reqData?.questionId ? reqData?.questionId : reqData
    let payload
    if (reqData !== undefined) {
      payload = JSON.parse(JSON.stringify(reqData))
      delete payload.type
    }
    const url = `${
      Question.baseUrl + this.adminEndPoint + this.endpoint
    }/${quizId}/question/${questionId}?type=${
      reqData?.type === 't/f' ? 'mcq' : reqData?.type
    }`
    const response = await this.fetcher.postData(url, payload)
    return response
  }
}
